/**
 * /tenants/$slug/agents/approval-analytics — RETIRED route, kept as a redirect.
 *
 * The "Trends" sub-tab folded into two homes: the tenant edge-decision heartbeat now
 * renders on the Activity landing (its data already rides that page's response), and the
 * approval funnel/trend/top-escalating summary sits atop the standalone Approval log.
 * Old deep links land there with their window preserved (?days flows through).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { analyticsWindowSchema } from "@/features/agent-approval-analytics/schemas";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/approval-analytics")({
  validateSearch: analyticsWindowSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/tenants/$slug/agents/approval-history",
      params: { slug: params.slug },
      search: { days: search.days, offset: 0 },
      replace: true,
    });
  },
});
